import React from 'react';
import { LatLng } from 'leaflet';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions';

import AbstractMapView from './AbstractMapView';
import { MarkerCamera, MarkerCameraSelecionada } from '../components/mapa/Marker';
import CardCamera from '../components/CardCamera';

class Cameras extends AbstractMapView {
  registerListener() {
    this.props.registerCamerasListeners();
  }

  unregisterListener() {
    this.props.unregisterCamerasListeners();
    this.props.resetCameras();
  }

  componentWillReceiveProps(nextProps) {
    return super.componentWillReceiveProps(nextProps)
      .then(() => {
        const coordenadas = nextProps.cameraSelecionada.coordenadas;
        if (coordenadas) {
          this.map.setView(new LatLng(coordenadas[0], coordenadas[1]));
        }
      });
  }

  render() {
    const cameraSelecionada = this.props.cameraSelecionada;
    const selecionaCamera = this.props.selecionaCamera;

    return (
      <div>
        {
          cameraSelecionada.key &&
          <CardCamera
            camera={ cameraSelecionada }
            camerasProximas={ this.getCamerasProximas() }
            selecionaCamera={ this.selecionaCamera2.bind(this) }
            onClose={ selecionaCamera.bind(this, {}) }
            videoUrl={ this.props.videoUrl }
          />
        }
        <div id="main-map"></div>
      </div>
    );
  }

  onClickCamera(camera, nextProps) {
    const key = camera.target.options.id;
    const cameraSelecionada = nextProps.cameras.find(c => c.key === key);
    this.selecionaCamera2(cameraSelecionada);
  }

  getCamerasProximas() {
    const { cameras, cameraSelecionada } = this.props;

    if (Array.isArray(cameraSelecionada.coordenadas)) {
      const [refLat, refLng] = cameraSelecionada.coordenadas;
      const ref = new LatLng(refLat, refLng);

      return cameras
        .map(camera => {
          const [lat, lng] = camera.coordenadas;
          return Object.assign({}, camera, {distancia: ref.distanceTo(new LatLng(lat, lng))});
        })
        .sort((a, b) => a.distancia - b.distancia)
        .filter(camera => camera.key !== cameraSelecionada.key)
        .slice(0, 20);
    }

    return [];
  }

  updateMarkersLayer(nextProps) {
    const idSelecionado = this.props.cameraSelecionada.key;

    this.markerLayers.removeLayers(this.markerLayers.getLayers())
    nextProps.cameras
      .sort((a, b) => a.key.localeCompare(b.key))
      .forEach(camera => {
        const id = camera.key;
        camera.id = id;

        const marker = (id === idSelecionado) ? MarkerCameraSelecionada : MarkerCamera;
        this.markerLayers.addLayer(
          marker(camera.coordenadas, camera, camera => this.onClickCamera(camera, nextProps))
        );
      });
  }

  selecionaCamera2(camera) {
    this.props.updateVideoUrl(camera.videoUrl);
    this.props.selecionaCamera(camera);
    this.props.registerTimelineListener(camera.key);
  }
}

const mapStateToProps = (state) => ({
  cameras: state.cameras,
  cameraSelecionada: state.cameraSelecionada,
  listeningMarkable: state.listeningCameras,
  localizacao: state.localizacao,
  localizacaoIsLoading: state.localizacaoIsLoading,
  raio: state.raio,
  timeline: state.timeline,
  videoUrl: state.videoUrl,
});
const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Cameras);



// WEBPACK FOOTER //
// ./src/containers/Cameras.js